// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import { ArrayPage } from "../../core/pagination.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Tools extends APIResource {
    /**
     * Get tools from an existing agent.
     */
    list(agentID, query = {}, options) {
        return this._client.getAPIList(path `/v1/agents/${agentID}/tools`, (ArrayPage), {
            query,
            ...options,
        });
    }
    /**
     * Attach a tool to an agent.
     */
    attach(toolID, params, options) {
        const { agent_id } = params;
        return this._client.patch(path `/v1/agents/${agent_id}/tools/attach/${toolID}`, options);
    }
    /**
     * Detach a tool from an agent.
     */
    detach(toolID, params, options) {
        const { agent_id } = params;
        return this._client.patch(path `/v1/agents/${agent_id}/tools/detach/${toolID}`, options);
    }
    /**
     * Trigger a tool by name on a specific agent, providing the necessary arguments.
     *
     * This endpoint executes a tool that is attached to the agent, using the agent's
     * state and environment variables for execution context.
     */
    run(toolName, params, options) {
        const { agent_id, ...body } = params;
        return this._client.post(path `/v1/agents/${agent_id}/tools/${toolName}/run`, { body, ...options });
    }
    /**
     * Modify the approval requirement for a tool attached to an agent.
     *
     * Accepts requires_approval via request body (preferred) or query parameter
     * (deprecated).
     */
    updateApproval(toolName, params, options) {
        const { agent_id, query_requires_approval, ...body } = params;
        return this._client.patch(path `/v1/agents/${agent_id}/tools/approval/${toolName}`, {
            query: { requires_approval: query_requires_approval },
            body,
            ...options,
        });
    }
}
//# sourceMappingURL=tools.mjs.map